import axiosInstance from '@/services/api/axiosInstance';

/** GET /public/card-types — what is on sale. */
export async function listTypes() {
  const res = await axiosInstance.get('/public/card-types');
  return res.data.data ?? res.data;
}

/** GET /user/cards — my cards, and how long my photos are kept. */
export async function myCards() {
  const res = await axiosInstance.get('/user/cards');
  return res.data.data ?? res.data;
}

/**
 * POST /user/cards/buy — same shape as a consultation payment: a named gateway
 * returns { paymentUrl }; with no gateway the server settles it directly.
 */
export async function buy(typeCode, gateway, discountCode) {
  const body = { typeCode };
  if (gateway) body.gateway = gateway;
  if (discountCode) body.discountCode = discountCode;
  const res = await axiosInstance.post('/user/cards/buy', body);
  return res.data.data ?? res.data;
}

export const cardsApi = { listTypes, myCards, buy };
export default cardsApi;
